var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 566.929,
    height: 377.953,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.537 37.09h353.672v207.791H22.536Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 283.465h425.197V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 377.953)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.193-.69L0 0",
    style: {
      fill: "#b22e4c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(23.73 143.819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-17.893-28.263-69.009-32.398-69.009-4.134 0-32.397 51.116-32.397 69.009s14.505 32.398 32.397 32.398C-14.505 32.398 0 17.893 0 0",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(376.209 212.483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-9.533-7.728-17.26-17.26-17.26-9.533 0-17.261 7.727-17.261 17.26 0 9.533 7.728 17.26 17.261 17.26C-7.728 17.26 0 9.533 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(361.072 212.778)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c10.524 15.297 15.968 26.415 24.774 43.36.607 1.167 44.312 10.23 70.341 14.464-6.881 9.644-11.851 15.612-15.707 22.229-7.273 12.48-4.312 23.766 10.353 24.68 37.331 2.327 75.542 2.339 112.968 2.893l7.212-9.737-84.889-15.203c11.592-9.492 20.423-15.828 28.178-23.283 11.819-11.36 9.488-27.353-5.785-30.833C101.551 18.116 46.91 9.492 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(124.809 47.833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-33.414-52.78-128.873-60.502-128.873-7.721 0-60.501 95.459-60.501 128.873 0 33.414 27.088 60.501 60.501 60.501C-27.088 60.501 0 33.414 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(164.75 165.963)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-17.802-14.431-32.233-32.233-32.233S-64.466-17.802-64.466 0s14.431 32.233 32.233 32.233S0 17.802 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(136.481 166.514)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalNav);
export default __webpack_public_path__ + "static/media/personal_nav.ee8b9890f41c973f472f7c249079e571.svg";
export { ForwardRef as ReactComponent };